/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Configuration campaing
 */
export interface CampainInfo {
  telephoneNumber?: string;
  initialImage?: string;
  specialTariffImage?: string;
  campaignCode?: string;
  marketingId?: string;
  cooperationId?: string;
}
